export default __webpack_public_path__ + "static/media/MaterialsImg.298ba33d.jpg";